import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { Header } from "../../Components/Header/Header";
import { orderData } from "../data";
import { IRows } from "../../Components/Filter/WSFilterComponent";
import { HeaderList } from "../../Components/Header/HeaderList";
import { useDispatch } from "react-redux";
import {
  resetDataComponent,
  updateDataComponent
} from "../../StateManagement/actions";
import { IMetaData } from "../../Components/Dialog/WSCommonDialog";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import {
  callAPI,
  getLocalValue,
  IRoleMain,
  LoacalVariables,
  Method,
  toTitleCase,
  TransactionPages
} from "../../commonFunctions/CommonFunctions";
import { openPopUp } from "../../Components/Dialog/OpenNewModal";
import clientconfig from "../../Config/clientConfig.json";
import { UpdatePayment } from "./UpdatePayment";
import QRCodeComponent from "./QRCode";
import { PaidList } from "./PaidList";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
export const PaymentList: React.FC<any> = () => {
  const [orderId, setOrderID] = useState<any>();
  const { add, view, exports } = getPermissions(
    TransactionPages.PaymentList,
    IRoleMain.Transactions
  );
  const [totalCount, setTotalCount] = useState<any>();
  const [filterChanged, setFilterChanged] = useState<any>(false);

  //for loyalty;
  const [paymentId, setPaymentId] = useState<any>("");
  const [customerId, setCustomerId] = useState<any>("");
  const [finalAmount, setFinalAmount] = useState(0);
  const [customerName, setCustomerName] = useState<any>("");
  const [proceed, setProceed] = useState<boolean>(false);
  const [redeemPoints, setRedeemPoints] = useState<number>(0);

  const { showMessage } = useSnackbar();
  const dispatch = useDispatch();

  const columns: IColumns[] = [
    {
      header: "Order#",
      fieldName: "orderNumber",
      type: "default",
      sortable: true,
      sortKey: "OrderNumber"
    },
    {
      header: "Name",
      fieldName: "customerName",
      type: "default"
      // sortable: true,
      // sortKey: "id"
    },

    { header: "Phone", fieldName: "phoneNumber", type: "default" },
    { header: "Is Home Delivery", fieldName: "homeDelivery", type: "default" },
    { header: "Status", fieldName: "orderStatus", type: "status" },
    {
      header: "Ordered On",
      fieldName: "orderDate",
      type: "date",
      sortable: true
    },
    {
      header: "Expected Delivery",
      fieldName: "deliveryDate",
      type: "date",
      sortable: true
    },
    {
      header: "Total Price",
      fieldName: "finalAmount",
      type: "default"
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [add ? "Add Payment" : undefined],
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];

  const filterRows: IRows[] = [
    {
      label: "Order#",
      fieldName: "OrderNumber",
      type: "text",
      operator: "like",
      rowDivision: 6
    },
    {
      label: "Customer Name",
      fieldName: "CustomerName",
      type: "text",
      operator: "like",
      rowDivision: 6
    }
  ];

  const source = {
    url: "orders/search",
    page: 1,
    pageSize: 10,
    filter: [
      { field: "OrderStatus", operator: "eq", value: "Completed" }
      // {
      //   field: "FranchiseId",
      //   operator: "eq",
      //   value: getLocalValue(LoacalVariables.FranchiseId)
      // }
    ],
    sort: []
  };
  const transFormData = (data: any, totalCount: any) => {
    setTotalCount(totalCount);
    if (data && data?.length > 0) {
      data?.map((item: any) => {
        item.homeDelivery = item?.isHomeDelivery ? "Yes" : "No";
        item.status = toTitleCase(item.orderStatus);
      });
      return data;
    }
  };
  const handlePayment = async (data: any) => {
    try {
      const response: any = await saveData(data);
      if (response && data.applyPoints) {
        await callAPI("loyalty/redeem", Method.POST, {
          customerId: customerId,
          pointsEarned: redeemPoints,
          pointsUsed: redeemPoints
        });
      }
      dispatch(resetDataComponent("paymentGrid"));
      showMessage(
        response.message,
        response.success === true ? "success" : "error"
      );
    } catch (e: any) {
      showMessage(e.error);
    }
  };
  const saveData = async (data: any) => {
    const request: any = {
      amountPaid: data?.amountPaid,
      paymentMethod: data?.paymentMethod,
      orderId: data?.paymentId
    };

    const response: any = await callAPI(`payments`, Method.POST, request);
    return response;
  };

  const handleAction = async (action: string, row: any) => {
    if (action === "Add Payment") {
      const paymentIdLocal = row?.orderId;
      const customerIdLocal = row?.customerId;
      const customerNameLocal = row?.customerName;
      const finalAmountLocal = row?.finalAmount;

      setPaymentId(paymentIdLocal);
      setCustomerId(customerIdLocal);
      setCustomerName(customerNameLocal);
      setFinalAmount(finalAmountLocal);

      // Fetch loyalty points directly
      let availablePointsLocal = 0;
      try {
        const response: any = await callAPI(
          "loyalty/points",
          Method.GET,
          {},
          customerIdLocal
        );
        if (response) {
          availablePointsLocal = response.availablePoints;
        }
      } catch (error) {
        console.error("failed to retrieve loyalty data", error);
      }

      const metadataPayment: IMetaData = {
        title: "Tasks",
        hideActions: false,
        content: (props: any) => (
          <UpdatePayment
            {...props}
            paymentId={paymentIdLocal}
            customerId={customerIdLocal}
            customerName={customerNameLocal}
            orderTotal={finalAmountLocal}
            availablePoints={availablePointsLocal}
            redeemPoints={availablePointsLocal}
            setRedeemPoints={setRedeemPoints}
            // setProceed={setProceed}
          />
        ),
        actions: [
          {
            label: "Cancel",
            className: "ws-cancel",
            type: "button"
          },
          {
            label: "Submit",
            onClick: handlePayment,
            type: "submit",
            autoFocus: true
          }
        ],
        isDragable: true
      };
      openPopUp(metadataPayment, handlePayment, "40rem");
    }
  };

  return (
    <>
      <HeaderList
        title="Payments"
        type="card"
        info={`${totalCount || 0} Total Records`}
      />
      {view ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <WSDataGrid
              id="paymentGrid"
              title="Payments"
              headerType="HaderTopCornered"
              columns={columns}
              filterFields={filterRows}
              source={source}
              transFormData={transFormData}
              isFilterChanged={filterChanged}
              exportCsv={exports}
            />
          </Grid>
        </Grid>
      ) : (
        <PermissionDenied />
      )}
    </>
  );
};
